import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary, H2 } from '@liveauctioneers/hammer-ui-core/text';

import { CoverageBlock } from './components/CoverageBlock/CoverageBlock';

export const COVERED_ITEMS = [
    'Items that arrive significantly different from their listing description',
    'Items missing a described feature (e.g., certificate of authenticity)',
    'Items that are damaged in transit and not disclosed in advance (if shipped with LiveAuctioneers Shipping)',
    'Items that are never delivered (if shipped with LiveAuctioneers Shipping)',
    'Unauthorized transactions or payment issues reported within 5 days of your card being charged',
    'Items must be purchased through LiveAuctioneers checkout to qualify',
];

export const NOT_COVERED_ITEMS = [
    'Disputes related to authenticity, provenance, or attribution',
    "Buyer's remorse or personal dissatisfaction with the item",
    'Minor condition discrepancies (dimensions, coloring or age-appropriate wear)',
    'Shipping delays',
    'Disputes that arise after the item has been materially altered or resold',
    'Items more than $5,000 in total hammer value',
    'Purchases made by paying the auction house directly (partially or in full)',
];

export const PurchaseProtectionCoverage = () => {
    const { formatMessage } = useIntl();
    return (
        <div className="px-md py-xl xsMax:px-sm xsMax:pb-2xl xsMax:pt-lg">
            <div className="mx-auto flex max-w-[1200px] flex-col gap-lg xsMax:gap-md">
                <H2>{formatMessage({ id: 'purchaseProtectionPage.coverage.title' })}</H2>
                <div className="grid grid-cols-2 gap-md xsMax:grid-cols-1 xsMax:pb-0">
                    <CoverageBlock
                        isCovered
                        items={COVERED_ITEMS}
                    />
                    <CoverageBlock
                        isCovered={false}
                        items={NOT_COVERED_ITEMS}
                    />
                </div>
                <div className="flex max-w-[690px] flex-col gap-xs">
                    <BodyPrimary>{formatMessage({ id: 'purchaseProtectionPage.coverage.description' })}</BodyPrimary>
                    <BodyPrimary>{formatMessage({ id: 'purchaseProtectionPage.coverage.coverageDate' })}</BodyPrimary>
                </div>
            </div>
        </div>
    );
};
